export default (to, from, next) => {
  const titles = [];
  to.matched.forEach((route) => {
    const title = route.meta.title;
    if (title) titles.unshift(title);
  });
  titles.push('Goliath');
  document.title = titles.join(' — ');
  next();
};



// WEBPACK FOOTER //
// ./router/title-handler.js